export default "__VITE_ASSET__DmWJb5fN__"